import {Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {hasPermission} from "../model/user";
import {PermissionName} from "../utils/constants";

@Directive({
  selector: '[awIsInAnyRole]'
})
export class IsInAnyRoleDirective implements OnInit, OnDestroy {

  private hasView = true;
  private showIfInAnyRole: PermissionName[] = [];

  constructor(
    private authService: AuthService,
    private viewContainer: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
  }

  @Input() set awIsInAnyRole(value: PermissionName[]) {
    this.showIfInAnyRole = value;
  }

  ngOnInit(): void {
    this.viewContainer.clear();
    this.hasView = false;
    const user = this.authService.loggedUser();
    if (this.hasView && this.showIfInAnyRole.find(role => hasPermission(user, role) )) {
      this.viewContainer.clear();
      this.hasView = false;
    } else if (!this.hasView && this.showIfInAnyRole.find(role => hasPermission(user, role))) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    }
  }

  ngOnDestroy(): void {
  }

}
